var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import InputMask from "react-input-mask";
import CurrencyInput from "./CurrencyInput";
import DownPayment from "./DownPayment";
import { useState, useEffect } from "react";
var normalizeMask = function (m) { return m === null || m === void 0 ? void 0 : m.replace(/[（）]/g, function (x) { return (x === "（" ? "(" : ")"); }).replace(/&lpar;|&rpar;/g, function (x) { return (x === "&lpar;" ? "(" : ")"); }).replace(/\u200B|\u200C|\u200D|\uFEFF/g, "").trim(); };
export default function InputText(_a) {
    var field = _a.field, onChange = _a.onChange, onBlur = _a.onBlur, touched = _a.touched, isLastStep = _a.isLastStep;
    return (_jsx(PlainInputText, { field: field, onChange: onChange, onBlur: onBlur, touched: touched, isLastStep: isLastStep }));
}
function PlainInputText(_a) {
    var field = _a.field, onChange = _a.onChange, onBlur = _a.onBlur, touched = _a.touched, isLastStep = _a.isLastStep;
    var fieldConfig = field.config;
    var _b = useState(false), blurred = _b[0], setBlurred = _b[1];
    var _c = useState(false), focused = _c[0], setFocused = _c[1];
    useEffect(function () {
        if (fieldConfig.inputType === "tel" && field.fieldValue === "(")
            onChange("");
    }, []);
    var handleFocus = function () {
        var _a;
        setFocused(true);
        var v = (_a = field.fieldValue) !== null && _a !== void 0 ? _a : "";
        onChange(v, true);
    };
    var handleBlur = function (val) {
        var _a;
        setBlurred(true);
        setFocused(false);
        var v = (_a = val !== null && val !== void 0 ? val : field.fieldValue) !== null && _a !== void 0 ? _a : "";
        onChange(v, true);
        onBlur();
    };
    var showError = !field.isValid && (touched || blurred);
    var showSuccess = field.isValid && (touched || blurred) && field.fieldValue !== "";
    var fieldClass = [
        fieldConfig.className || "",
        showError ? "field-error" : "",
        showSuccess ? "field-success" : ""
    ]
        .filter(Boolean)
        .join(" ")
        .trim();
    var labelToShow = isLastStep && fieldConfig.labelAlt ? fieldConfig.labelAlt : fieldConfig.label;
    var masked = normalizeMask(fieldConfig.inputMask);
    var props = __assign(__assign(__assign(__assign(__assign(__assign(__assign({ id: fieldConfig.fieldId, value: field.fieldValue || "", onChange: function (e) { return onChange(e.target.value); }, onFocus: handleFocus, onBlur: function () { return handleBlur(); } }, (fieldConfig.placeholder ? { placeholder: fieldConfig.placeholder } : {})), (fieldConfig.autoComplete ? { autoComplete: fieldConfig.autoComplete } : {})), (fieldConfig.autoCorrect ? { autoCorrect: fieldConfig.autoCorrect } : {})), (fieldConfig.minLength != null ? { minLength: fieldConfig.minLength } : {})), (fieldConfig.maxLength != null ? { maxLength: fieldConfig.maxLength } : {})), (fieldConfig.spellCheck ? { spellCheck: fieldConfig.spellCheck } : {})), { className: fieldClass, "aria-invalid": showError ? "true" : "false" });
    switch (fieldConfig.inputType) {
        case "currency":
            return (_jsx(CurrencyInput, { field: field, onChange: onChange, onBlur: function () { return handleBlur(); } }));
        case "downPayment":
            return (_jsx(DownPayment, { field: field, onChange: onChange, onBlur: function () { return handleBlur(); } }));
        case "tel":
            return (_jsxs("div", { className: "textbox", children: [labelToShow ? (_jsx("label", { htmlFor: fieldConfig.fieldId, children: labelToShow })) : (_jsx("label", { htmlFor: fieldConfig.fieldId, className: "visually-hidden", children: fieldConfig.placeholder || "Phone number" })), _jsx(InputMask, { mask: masked || "(999) 999-9999", maskChar: null, value: field.fieldValue || "", onChange: function (e) {
                            return onChange(e.target.value);
                        }, onFocus: handleFocus, onBlur: function (e) {
                            var v = e.target.value;
                            var cleaned = v === "(" ? "" : v;
                            handleBlur(cleaned);
                        }, children: function (inputProps) { return (_jsx("input", __assign({}, inputProps, { id: fieldConfig.fieldId, type: "tel", placeholder: fieldConfig.placeholder || "", className: fieldClass, inputMode: "tel", autoComplete: fieldConfig.autoComplete || "tel", "aria-invalid": showError ? "true" : "false" }))); } })] }));
        default:
            var hasMask = !!masked;
            return (_jsxs("div", { className: "textbox", children: [labelToShow ? (_jsx("label", { htmlFor: fieldConfig.fieldId, children: labelToShow })) : (_jsx("label", { htmlFor: fieldConfig.fieldId, className: "visually-hidden", children: fieldConfig.placeholder || "Input field" })), hasMask ? (_jsx(InputMask, { mask: masked, maskChar: null, value: field.fieldValue || "", onChange: function (e) {
                            return onChange(e.target.value);
                        }, onFocus: handleFocus, onBlur: function () { return handleBlur(); }, children: function (inputProps) { return (_jsx("input", __assign({}, inputProps, { id: fieldConfig.fieldId, type: fieldConfig.inputType || "text", placeholder: fieldConfig.placeholder || "", className: fieldClass, autoComplete: fieldConfig.autoComplete || "off", "aria-invalid": showError ? "true" : "false" }))); } })) : (_jsx("input", __assign({ type: fieldConfig.inputType || "text" }, props, { autoComplete: fieldConfig.autoComplete || "off" })))] }));
    }
}
